import { useRecoilValue, useSetRecoilState } from 'recoil';
import { StorageManager } from '@aws-amplify/ui-react-storage';
import UploadIcon from '@mui/icons-material/Upload';
import { S3File, displayModelState, prefixState, fileRenderKeyState } from 'features/file-browser/state/fileAtoms';
import { CustomButton } from 'shared/ui/CustomButton';
import { useState, useEffect } from 'react';
import { cognitoIdState } from 'features/auth/state/authAtoms';

const getModelName = (displayModel: S3File | null) => {
  if (!displayModel) {
    alert('対応するベースモデルを描画して下さい。');
    return null;
  }
  return displayModel.name.replace(/\.[^/.]+$/, "");
};

const getPathAndDisable = (
  prefix: string,
  cognitoId: string,
  displayModel: S3File | null
): { path: string; disable: boolean } => {
  let modelName = (prefix === 'cocoon' || prefix === 'tire' || prefix === 'wheelhouse') ? getModelName(displayModel) : '';
  if ((prefix === 'cocoon' || prefix === 'tire' || prefix === 'wheelhouse') && modelName === null) return { path: '', disable: true };

  const paths = {
    model: `from-web-app/${cognitoId}/model/`,
    cocoon: `from-web-app/${cognitoId}/pre-cocoon/${modelName}/`,
    tire: `from-web-app/${cognitoId}/tire/${modelName}/`,
    wheelhouse: `from-web-app/${cognitoId}/wheelhouse/${modelName}/`
  };

  return {
    path: prefix in paths ? paths[prefix as keyof typeof paths] : '',
    disable: !(prefix in paths)
  };
};

export const UploadButton: React.FC = () => {
  const setRenderKey = useSetRecoilState(fileRenderKeyState);
  const cognitoId = useRecoilValue(cognitoIdState);
  const displayModel = useRecoilValue(displayModelState);
  const prefix = useRecoilValue(prefixState);

  const [path, setPath] = useState<string>("");
  const [disable, setDisable] = useState<boolean>(false);

  // Use `useEffect` to run `getPathAndDisable` only once
  useEffect(() => {
    const { path, disable: initialDisable } = getPathAndDisable(prefix, cognitoId, displayModel);
    setDisable(initialDisable);
    setPath(path);
  }, [prefix, cognitoId, displayModel]);

  return (
    <StorageManager
      path={path}
      acceptedFileTypes={['.stl']}
      maxFileCount={10}
      onUploadSuccess={() => setRenderKey((prevKey) => prevKey + 1)}
      components={{
        DropZone({ children }) {
          return <div>{children}</div>;
        },
        FilePicker({ onClick }) {
          return (
            <CustomButton
              sx={{ fontSize: '10px', width: '100%' }}
              disabled={disable}
              size="small"
              onClick={onClick}
              startIcon={<UploadIcon />}
            >
              Upload
            </CustomButton>
          );
        }
      }}
    />
  );
};
